import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-white" data-id="element-17" data-mp="bfj6p4q0ph8">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8" data-id="element-18" data-mp="3iqztf3fsgbxb">
        <SectionHeader id="beneficios" title="¿Qué puede cambiar cuando empiezas?" description="Una clase organizada puede cambiar la forma de enseñar electrónica." data-id="element-19" data-mp="3npb6dn1dr2jr" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="3dr3sjd2e10lz">
          {benefits.map(b => {
          const Icon = b.icon;
          return <li key={b.title} className="flex gap-2.5 rounded-lg border border-navy/10 bg-mist p-2.5 sm:p-3" data-id="element-21" data-mp="2zsnknissh429">
                <span aria-hidden="true" className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md bg-brand text-energy" data-id="element-22" data-mp="34qysxp3fr6id">
                  <Icon size={16} data-id="element-23" data-mp="12yk5ybm1bbv3" />
                </span>
                <div data-id="element-24" data-mp="2benrn9f645kc">
                  <h3 className="font-condensed text-[0.95rem] font-bold leading-tight text-navy" data-id="element-25" data-mp="2be4bny92vr8y">{b.title}</h3>
                  <p className="mt-0.5 text-[0.8rem] leading-snug text-navy/75 sm:text-sm" data-id="element-26" data-mp="27d2km4pbeli2">{b.desc}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}